import {
  // updatePrice,
  createPrice,
  getPhotosByGalleryName,
  removePhotosByIds,
  getImgGallery,
  upDatePhotoPriceByGalleryId,
} from "../apis/index";
import {
  getLoggedInUserId,
} from "../v2_actions/auth";

export const setGalleryFilterItem = (filterItem) => ({
  type: "GALLERY/SETGALLERYFILTERITEM",
  filterItem,
});

export const setEditingGallery = (editGalleryAble) => ({
  type: "GALLERY/EDITGALLERYABLE",
  editGalleryAble,
});

export const setAddingPhotos = (addingPhotosGallery) => ({
  type: "GALLERY/ADDINGPHOTOS",
  addingPhotosGallery,
});

export const setShowMapViewAble = (mapSearchViewAble) => ({
  type: "GALLERY/SETMAPVIEWABLE",
  mapSearchViewAble,
});

export const setUpdateGallery = (updateGallery) => ({
  type: "GALLERY/SETUPDATEGALLEY",
  updateGallery,
});

export const addGalleryCount = (galleryCount) => ({
  type: "GALLERY/ADDCOUNT",
  galleryCount,
});

export const removeGalleryCount = (galleryCount) => ({
  type: "GALLERY/REMOVECOUNT",
  galleryCount,
});

export const setAllChecked = (allChecked) => ({
  type: "GALLERY/ALLCHECKED",
  allChecked,
});

export const setGalleryPrice = (galleryPrice) => ({
  type: "GALLERY/SETGALLERYPRICE",
  galleryPrice,
});

export const setGalleryDateTimeInfo = (galleryDateTimeInfo) => ({
  type: "GALLERY/SETGALLEYDATETIMEINFO",
  galleryDateTimeInfo,
});

export const setImageGalleryAllList = (galleryAllList) => ({
  type: "GALLERY/SETGALLERYLIST",
  galleryAllList,
});

export const getPhotosByGallery = (galleryPhotos) => ({
  type: "GALLERY/GETPHOTOSBYGALLERY",
  galleryPhotos,
});

export const getPids = (pIds) => ({
  type: "GALLERY/GETPIDS",
  pIds,
});

export const getGalleryName = (galleryName, galleryId) => ({
  type: "GALLERY/GALLERYNAME",
  galleryName,
  galleryId,
});

export const addPrice = (price) => ({
  type: "GALLERY/SETPRICE",
  price,
});

export const setZoomIndex = (zoomIndex) => ({
  type: "GALLERY/SETZOOMINDEX",
  zoomIndex,
});

export const setLoadingSpiner = (showSpiner) => ({
  type: "GALLERY/SETLOADINGSPINER",
  showSpiner,
});

export const setPercentLoader = (percentLoader) => ({
  type: "GALLERY/SETPERCENTLOADER",
  percentLoader,
});

export const setDrawWidth = (drawWidth) => ({
  type: "GALLERY/SETDRAWWIDTH",
  drawWidth,
});

export const setShowDelRes = (showDelRes) => ({
  type: "GALLERY/SETSHOWDELRES",
  showDelRes,
});

export const setSelectedGallery = (gallery) => ({
  type: "GALLERY/SETSELECTEDGALLERY",
  payload: gallery,
});

export const setGalleryPriceApiAction = (payload, priceId) => {
  return (dispatch) => {
    if (priceId == null) {
      createPrice(payload).then((res) => {
        if (res) {
          if (res.data === "success") dispatch(setGalleryPrice(payload));
        }
      });
    }
  };
};

export const upDatePhotoPriceByGid = (sendData, galleryId) => {
  return (dispatch) => {
    upDatePhotoPriceByGalleryId(sendData, galleryId).then((res) => {
      if (res.data === "success") {
        dispatch(getPhotosByGalleryNameAction(galleryId));
      }
    });
  };
};

export const getImageGalleryAction = () => {
  const authId = getLoggedInUserId();
  return (dispatch) => {
    getImgGallery(authId).then((res) => {
      dispatch(setImageGalleryAllList(res.data));
    });
  };
};

export const getPhotosByGalleryNameAction = (galleryId) => {
  return (dispatch) => {
    if (galleryId !== null) {
      getPhotosByGalleryName(galleryId).then((res) => {
        if (res) {
          dispatch(getPhotosByGallery(res.data.results));
        }
      });
    }
  };
};

export const removePhotoAction = (pIds, galleryId, galleryName) => {
  return (dispatch) => {
    if (pIds !== null) {
      removePhotosByIds(pIds, galleryId).then((res) => {
        if (res.data === "success") {
          dispatch(getPhotosByGalleryNameAction(galleryId));
          dispatch(addGalleryCount(0));
          dispatch(getPids([]));
          dispatch(getImageGalleryAction());
          dispatch(getGalleryName(galleryName, galleryId));
          dispatch(setShowDelRes("success"));
        } else if (res.data === "sold") {
          dispatch(setShowDelRes("sold"));
        } else {
          dispatch(getPhotosByGallery(null));
          dispatch(addGalleryCount(0));
          dispatch(getPids([]));
          dispatch(getImageGalleryAction());
          dispatch(getGalleryName(false, false));
          dispatch(setShowDelRes("removegallery"));
        }
      });
    }
  };
};
